/**
 * O teto do aviso de privacidade — ESPELHO do cânone, com trava.
 *
 * `admin.v1.yaml` → `PublishAvisoPlataformaRequest.properties.texto.maxLength`. O
 * `openapi-typescript` não traz `maxLength` para o runtime (nenhum tipo gerado carrega um
 * número), então o painel precisa de uma constante — e uma constante espelhada sem prova é um
 * comentário que envelhece. A prova está em `tests/pipeline/canon-lockstep.test.ts`, que lê o
 * YAML e compara; e o mesmo teste recusa qualquer arquivo do painel que volte a escrever o
 * número à mão.
 *
 * O QUE ESTE NÚMERO SIGNIFICA (feature 066): um limite contra texto acidental ou patológico.
 * NÃO é um limite de transporte. Ele já foi 1600 porque se acreditava que o aviso precisava
 * caber numa única mensagem de WhatsApp; não precisa, e um aviso de privacidade de verdade não
 * cabe. Quem escrever cópia para esta tela não deve reintroduzir aquela explicação.
 */
export const LIMITE_AVISO_PRIVACIDADE = 20000;
